import React, { PropTypes } from 'react';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import constants from "../../../common/constants";

const AccountDepositTransactionListRow = ({ accountDepositTransaction, rowStyles }) => {

  return (
    <TableRow>
      <TableRowColumn style={rowStyles.column.date}>
        {accountDepositTransaction.dateToShow}
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.amount}>
        ${accountDepositTransaction.amount}
      </TableRowColumn>

    </TableRow>
  );
};

AccountDepositTransactionListRow.propTypes = {
  accountDepositTransaction: PropTypes.object.isRequired,
  rowStyles: PropTypes.object.isRequired,
};

export default AccountDepositTransactionListRow;



// WEBPACK FOOTER //
// client/adminPanel/panel/accounts/AccountDepositTransactionListRow.js